export const DeviceType = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
} as const;
export type DeviceType = (typeof DeviceType)[keyof typeof DeviceType];
